import { render, staticRenderFns } from "./ResourceNotFound.vue?vue&type=template&id=16406f4c&scoped=true&"
import script from "./ResourceNotFound.vue?vue&type=script&lang=js&"
export * from "./ResourceNotFound.vue?vue&type=script&lang=js&"
import style0 from "./ResourceNotFound.vue?vue&type=style&index=0&id=16406f4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16406f4c",
  null
  
)

export default component.exports